/**
 * Break-Points for the devices
 */

// Todo - discuss with UX team to get the correct breakpoints
export const DEVICE_WIDTHS = {
  MOBILE: '520px',
  TABLET: '800px',
  DESKTOP: '1024px',
};

export default DEVICE_WIDTHS;
